import '@vanilla-extract/css/vanilla.virtual.css?ve-css=LmlnMnUxejAgewogIHdpZHRoOiAxMDAlOwogIGhlaWdodDogMTAwJTsKfQ';
export var lottie = 'ig2u1z0';